let styles = {
    container: {
        background: 'white',
        padding: '2%',
        display: 'flex',
        justifyContent: 'center',
    },
    main_header: {
        padding:'0px',
        margin:'10px 0px',
        display:'flex',
        background: '#7d3cff',
    },
    title: {
        padding:'5px',
        color:'white',
        fontWeight:'800',
        background: '#7d3cff',
        textAlign:'center',
        fontSize:'18px'
    },
    row: {
        margin:'1% 0%',
        fontSize:'15px',
        fontWeight:'600'
    },
    table_header: {
        marginTop:'1%',
        padding:10,
        display:"flex",
        fontWeight:'600',
        color:'black'
    }

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/ExpenseInfo/style.js